export default state => ({
  ...state,
  indicatives: {
    ...state.indicatives,
    sort: undefined,
    sortOrder: undefined,
    items: undefined
  }
});
